import { Package, Subscription } from './subscription'

export enum SummaryFormFields {
  TaxNumber = 'taxNumber',
  Street = 'street',
  CompanyName = 'company',
  BuildingNumber = 'buildingNumber',
  ApartmentNumber = 'apartmentNumber',
  ZipCode = 'zipCode',
  City = 'city',
  PaymentMethod = 'paymentMethodId',
}

export interface SummaryFormValues {
  [SummaryFormFields.TaxNumber]: string
  [SummaryFormFields.Street]: string
  [SummaryFormFields.CompanyName]: string
  [SummaryFormFields.BuildingNumber]: string
  [SummaryFormFields.ApartmentNumber]: string
  [SummaryFormFields.ZipCode]: string
  [SummaryFormFields.City]: string
  [SummaryFormFields.PaymentMethod]: string
}

export interface PriceWithDiscount {
  price: number
  discount: number
}

export interface DiscountedPrice {
  total: number
  totalDiscountIncluded: number
  discountAmount: number
  taxAmount: number
  currencyCode: string
  promoCode: string
}

export interface PaymentMethod {
  id: string
  name: string
  imageUrl: string
}

export interface ApiCreateOrder {
  redirectUrl: string
  paymentRequired: boolean
}

export interface Cart {
  cartId: number | null
  currencyCode: string
  discountAmount: number
  price: number
  taxAmount: number
  total: number
}

export type CartDetails = Omit<DiscountedPrice, 'promoCode'>

export type AnyProduct = Subscription | Package
